import { useInternalHost } from '../internal';

export function useFetch(): typeof globalThis.fetch {
  return useInternalHost().fetch;
}
